import makeSettingsReducer from 'app/common/reducers/settings/makeSettingsReducer';


const favDefaultState = {
  assistance: true,
};

export default makeSettingsReducer('history', favDefaultState);
